import { useEffect } from 'react';
import ky from 'ky';
import { PublicDataActions } from 'state/actions';

interface LocaleLinks {
	서비스가이드: string;
	채널톡: string;
}

type LocalizedLinks = Record<string, LocaleLinks>;

export default function useOrganizeLinks(language: string) {
	useEffect(() => {
		const endpoint = process.env.GATSBY_URL_ENDPOINT;
		if (!endpoint) return;
		ky.get(endpoint)
			.json<LocalizedLinks>()
			.then((data) => {
				const links = data[language];
				if (!links) return;
				PublicDataActions.setServiceGuideLink(links.서비스가이드);
				PublicDataActions.setChanneltalk(links.채널톡);
				PublicDataActions.serServiceIntrodueLink(language);
			})
			.catch((e) => {
				console.error(e);
			});
	}, [language]);
}
